<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider small-content-column" fxLayout="column" fxLayoutGap="20px">
      <!-- row -->
      <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign.gt-md="center start" fxLayoutGap="20px">
        <!-- display component -->
        <div fxLayout="column" fxLayoutGap="20px" fxFlex.gt-md="65">
          <!-- breadcrumb -->
          <div>
            <span (click)="StateService.goto('/blog')" style="text-decoration: underline; cursor: pointer">Blog</span> >
            Artikel
          </div>

          <h2 *ngIf="doesNotExist">Der Blogbeitrag existiert nicht mehr.</h2>

          <app-blog-display *ngIf="blog" [live]="true" [entity]="blog"></app-blog-display>

          <comments *ngIf="blog" [entity]="blog"></comments>
        </div>
      </div>

      <app-blog-related-items
        [direction]="'horizontal'"
        [items]="otherBlogs"
        [title]="'Andere Beiträge in der selben Kategorie'"
      ></app-blog-related-items>

      <!-- related footer -->
      <app-blog-related-items
        [direction]="'horizontal'"
        [items]="mostViewed"
        [title]="'Das hat deine Kollegen interessiert'"
        *ngIf="mostViewed"
      ></app-blog-related-items>

      <div>
        <span (click)="StateService.goto('/blog')" style="text-decoration: underline; cursor: pointer">Blog</span> >
        Artikel
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
